import axios from 'axios'
import Vue from 'vue'
import AuthService from "@/service/AuthService";

export default class PlayerService {
    authService = new AuthService();
    config = {
        headers: { Authorization: `Bearer ${this.authService.getUserBearerToken()}` }
    };
    generateContract(id, name, bornDate, natinoality, address) {
        const data = {
            Id: id,
            Name: name,
            BornDate: bornDate,
            Nationality: natinoality,
            Address: address,
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Player/GenerateContractPDF', data,
            {
                ...this.config,
                responseType: 'blob'
            });
    }
    getPlayerProfile(playerId) {
        const data = {
            PlayerId: playerId
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Player/GetPlayerInfo', data, this.config);
    }
    getPlayerSkills(playerId) {
        const data = {
            PlayerId: playerId
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Player/GetPlayerSkillsSelected', data, this.config);
    }
    updatePlayerSkills(playerId, skills) {
        const data = {
            PlayerId: playerId,
            Skills: skills
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Player/UpdatePlayerSkills', data, this.config);
    }
    isTransferPlayer(playerId) {
        const data = {
            PlayerId: playerId
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Player/IsTransferPlayer', data, this.config);
    }
    savePlayerProfile(player, lang) {
        const data = {
            Player: player,
            Lang: lang
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Player/SavePlayerInfo', data, this.config);
    }
    askForDeletePlayer(userId, userProfile, playerName, reason) {
        const data = {
            UserId: userId,
            UserProfile: userProfile,
            PlayerName: playerName,
            Reason: reason
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Player/AskForDeletePlayer', data, this.config);
    }
    sendPlayerDeletedEmail(playerId, playerName) {
        const data = {
            PlayerId: playerId,
            PlayerName: playerName
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Player/SendPlayerDeletedEmail', data, this.config);
    }
    getPlayerOwner(playerId) {
        const data = {
            PlayerId: playerId
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Player/GetPlayerOwner', data, this.config);
    }
    getPlayerSkillsEvaluations(playerId) {
        const data = {
            PlayerId: playerId
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Player/GetPlayerSkillsEvaluations', data, this.config);
    }
    addPlayerProfileViewed(playerId) {
        const data = {
            PlayerId: playerId
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Player/AddProfileViewed', data, this.config);
    }
    getPlayerTransfersReport(fromTransfer) {
        const data = {
            FromTransfer: fromTransfer
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Player/GetPlayerTransfersReport', data, this.config);
    }
    updatePlayerAddress(playerId, fullAddress) {
        const data = {
            PlayerId: playerId,
            FullAddress: fullAddress
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Player/SavePlayerAddress', data, this.config);
    }
    updatePlayerLastExperience(playerId, experience) {
        const data = {
            PlayerId: playerId,
            Experience: experience
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Player/SavePlayerLastExperience', data, this.config);
    }
    updatePlayerActualStatus(playerId, actualStatus) {
        const data = {
            PlayerId: playerId,
            ActualStatus: actualStatus
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Player/SavePlayerActualStatus', data, this.config);
    }
    updatePlayerPhoneNumber(playerId, phoneNumber) {
        const data = {
            PlayerId: playerId,
            PhoneNumber: phoneNumber
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Player/SavePlayerPhoneNumber', data, this.config);
    }
    getPlayerContract(rootFolder) {
        const data = {
            Folder: rootFolder
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Player/contract', data, this.config);
    }
}